import React from 'react'

import { GenericAnalyticsClient } from '@acorns/web-utils'

import { trackAccountReopenWelcomeBackAgreementDocumentLinkTappedPayload } from 'generated/trackingEvents'
import { AllAcceptanceDocumentsQuery } from 'generated/types'
import { CLOSED_ACCOUNT_AGREEMENTS_CHECKBOX } from 'utils/testing/testIDs'

import {
  AgreementCheckbox,
  AgreementContainer,
  AgreementText,
} from './styled-components'

export const Agreements = ({
  isChecked,
  onClick,
  acceptanceDocuments,
  analytics,
  isRedesignVariant,
  redesignText,
}: {
  isChecked: boolean
  onClick: () => void
  acceptanceDocuments: AllAcceptanceDocumentsQuery['allAcceptanceDocuments']
  analytics?: GenericAnalyticsClient
  isRedesignVariant?: boolean
  redesignText?: string
}) => {
  const handleDocumentClick = (name: string) => {
    analytics?.track(
      ...trackAccountReopenWelcomeBackAgreementDocumentLinkTappedPayload({
        ctaTitle: name,
      }),
    )
  }

  return (
    <AgreementContainer isRedesignVariant={isRedesignVariant}>
      <AgreementCheckbox
        data-testid={CLOSED_ACCOUNT_AGREEMENTS_CHECKBOX}
        isChecked={isChecked}
        onClick={onClick}
        isRedesignVariant={isRedesignVariant}
      />
      <AgreementText isRedesignVariant={isRedesignVariant}>
        {redesignText ??
          'By choosing to reopen your account, you acknowledge and agree to the '}
        {acceptanceDocuments?.map(({ url, name }, index) => (
          <React.Fragment key={name}>
            <a
              href={url}
              target="_blank"
              rel="noreferrer"
              {...(isRedesignVariant && {
                onClick: () => handleDocumentClick(name),
              })}
            >
              {name}
            </a>
            {index !== acceptanceDocuments.length - 1 && ', '}
            {index === acceptanceDocuments.length - 2 && 'and '}
          </React.Fragment>
        ))}
        {'.'}
      </AgreementText>
    </AgreementContainer>
  )
}
